import {useEffect, useState} from 'react';
import { retrieveAllTodosForUsernameApi , deleteTodoApi} from "./api/TodoApiService"
import {  useAuth } from './security/AuthContext'
import { useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import {deleteTodoAction} from '../../redux/todosReducer'


export default function ListTodosComponent(){

    const { count } = useSelector((state) => state.counter);
    const dispatch = useDispatch();
    const today = new Date();
    const targetDate = new Date(today.getFullYear()+12,today.getMonth(),today.getDay())
    const navigate = useNavigate();
const [todos,setTodos] = useState([])

const [message,setMesasage] = useState(null)
const authContext = useAuth()

const username = authContext.username

//const todos = [
    // {id:1, description:'Learn AWS', done: false, targetDate:targetDate},
    // {id:2, description:'Learn Full Stack Dev',done: false, targetDate:targetDate},
    // {id:3, description:'Learn DevOps',done: false, targetDate:targetDate}
//]

useEffect( () =>refreshTodos(),[count] )


const afterIncrementCallback = () => {
    console.log('Callback function after incrementing count:', count);
    // You can perform additional actions here
  };




function refreshTodos(){

retrieveAllTodosForUsernameApi(username)
.then( response => setTodos(response.data))
.catch(
    setTodos(count)
)

}

 function deleteTodo(id,description){
    deleteTodoApi(username,id)
    .then( () => {
        setMesasage(`Delete  "${description}" todo`)
    refreshTodos()
     } )
.catch(error => console.log(error),
dispatch(deleteTodoAction(id)))
refreshTodos()
 }


 function updateTodo(id){
  //  navigate(`todo/${id}`, { replace: true })
  navigate(`../todo/${id}`)
    console.log(id)
 }


 function addNewTodo(){
    navigate('/todo/-1')
 }



    return(
        <div className="container">
         <h1>Things You Want To Do!</h1>
       {message &&  <div className='alert alert-warning'>{message}</div>}  
         <div>
          <table className='table'>
            <thead>
            <tr>
             
                <th>
                Description
                </th>
                <th>
                  Is Done?
                </th>
                <th>
                    Target Date
                </th>
                <th>
                    Delete
                </th>
                <th>
                    Update
                </th>
            </tr>
            </thead>
            <tbody>
                {todos.map( todo => (
                <tr key={todo.id} >
    
<td>
    {todo.description}
</td>
<td>
{todo.done.toString()}
</td>
<td>
{/*  {todo.targetDate.toDateString()}   */}
{todo.targetDate}
</td>
<td>
 <button className="btn btn-warning" onClick={() => deleteTodo(todo.id,todo.description)}>Delete</button>
 </td>
 <td>
 <button className="btn btn-success" onClick={() => updateTodo(todo.id)}>Update</button>
</td>
</tr>
                )
)}
            </tbody>
          </table>
<div className="btn btn-success m-5" onClick={addNewTodo}>Add New Todo</div>

         </div>
        </div>
    )
}

